import { defineComponent } from "vue";

import ReferralInformationForm from "./ReferralInformationForm/ReferralInformationForm.vue";
import PreadmissionNotes from "./PreadmissionNotes/PreadmissionNotes.vue";

export default defineComponent({
    components: {
        ReferralInformationForm,
        PreadmissionNotes
    }
});
